// extracted by mini-css-extract-plugin
export default {"container":"MainFaqFrame_container__gC7LV","askWrap":"MainFaqFrame_askWrap__M1EcG","isOpen":"MainFaqFrame_isOpen__WIrKJ","answerWrap":"MainFaqFrame_answerWrap__wlyC2"};